import React from "react";
import { Button } from "../../../common/Button/Button";
import Checkbox from "../../../common/Checkbox/Checkbox";
import ReactTable from "react-table";
import moment from "moment";
import "react-table/react-table.css";
import find from "lodash/find";
import { getServiceTypesMaster } from "../../../utils/localStorage";

export default function AdminServiceRequestTable(props) {
	const getServiceName = (original) => {
		if (!original) return;
		const found = find(getServiceTypesMaster(), {
			sServiceCode: original.sServiceCode,
		});
		if (found) {
			return found.sServiceName;
		}
		return "";
	};
	const columns = [
		{
			id: "checkbox",
			accessor: "",
			Header: (header) => {
				return (
					<Checkbox
						id={`checkbox-id-header`}
						checked={props.selectedServiceRequests.length === 10}
						onChange={() => {
							const updated = props.selectedServiceRequests.toggleAll(
								header.data,
								"_original"
							);
							props.onSelectServiceRequest(updated);
						}}
					/>
				);
			},
			Cell: ({ original }) => {
				return (
					<Checkbox
						id={`checkbox-id-${original.nResourceInstanceId}`}
						onChange={() => {
							const updated = props.selectedServiceRequests.addOrUpdate(
								original,
								"nResourceInstanceId"
							);
							props.onSelectServiceRequest(updated);
						}}
						checked={
							find(props.selectedServiceRequests, {
								nResourceInstanceId:
									original.nResourceInstanceId,
							}) !== undefined
						}
					/>
				);
			},
			width: 45,
			sortable: false,
			resizable: false,
			// show: false
		},
		{
			id: "nResourceInstanceId",
			Header: "Instance Id",
			accessor: "nResourceInstanceId",
		},
		{
			id: "sServiceCode",
			Header: "Service Name",
			accessor: "sServiceCode",
			width: 170,
			Cell: ({ original }) => {
				return <span>{getServiceName(original)}</span>;
			},
		},
		{
			id: "sPackageOfferTitle",
			Header: "Package/Offering Title",
			accessor: "sPackageOfferTitle",
			width: 150,
			Cell: ({ original }) => (
				<span>
					{original.sPackageOfferTitle ? 
					(
						original.sPackageOfferTitle
					) : 
					(
						""
					)}
				</span>
			),
		},
		{
			id: "nPackageInstanceId",
			Header: "Package/Offering Instance Id",
			accessor: "nPackageInstanceId",
			width: 100,
		},
		{
			id: "refFacilitator",
			Header: "Facilitator",
			accessor: "refFacilitator",
		},

		{
			id: "sEmailAddress",
			Header: "Customer Email",
			accessor: "sEmailAddress",
		},
		{
			id: "sContactNumber",
			Header: "Customer Contact",
			accessor: "sContactNumber",
		},
		{
			id: "refExternalServicePartner",
			Header: "External Service Partner",
			accessor: "refExternalServicePartner",
			Cell: ({ original }) =>
				original.refExternalServicePartner? (
					<span>
						{original.refExternalServicePartner.sName} 
						{original.ext_sp_org? (" ("+original.ext_sp_org+")"): ""}
					</span>
				) : (
					<span>{""}</span>
				),
			// width: 130,
		},
		{
			id: "sPaymentStatus",
			Header: "Payment Status",
			accessor: "sPaymentStatus",
			width: 125,
			Cell: ({ original }) =>
				original.sPaymentStatus ? original.sPaymentStatus : "N/A",
		},

		{
			id: "refSRState",
			Header: "Current State",
			accessor: "refSRState",
			Cell: ({ original }) =>
				original.refSRState === "Cancelled" ? (
					<span>
						{original.refSRState} {"-"}
						{original.sServiceCancellationReason === "Other"
							? original.sServiceCancellationReasonOtherDescription
							: original.sServiceCancellationReason}
					</span>
				) : (
					<span>{original.refSRState}</span>
				),
		},
		{
			id: "sBusinessPincode",
			Header: "Pincode",
			accessor: "sBusinessPincode",
			Cell: ({ original }) => (
				<span>
					{original.sBusinessPincode ? (
						<>
							<span title={`${original.sBusinessCity ?original.sBusinessCity:""}${" "}${original.sBusinessState ?original.sBusinessState:""}`}>{original.sBusinessPincode}</span>
						</>
					) : (
						""
					)}
				</span>
			),
		},
		{
			id: "bStayEngagedWithEhh",
			Header: "Stay Engaged with EHH",
			accessor: "bStayEngagedWithEhh",
			Cell: ({ original }) => (original.bStayEngagedWithEhh ? "Yes" : "No"),
		},
		{
			id: "bCouponApplied",
			Header: "Coupon Applied",
			accessor: "bCouponApplied",
			Cell: ({ original }) => (original.bCouponApplied ? "Yes" : "No"),
		},
		{
			id: "sCouponCode",
			Header: "Coupon Code",
			accessor: "sCouponCode"
		},
		{
			id: "fDiscountAmount",
			Header: "Coupon Discount Amount",
			accessor: "fDiscountAmount"
		},
	];
	const NoDataComponent = (p) => {
		return <div>No data</div>;
	};
	return (
		<>
			<ReactTable
				data={props.data || []}
				columns={columns}
				manual
				pages={props.pages}
				page={props.page}
				pageSize={props.pageSize}
				//style={{height: "600px",overflow: "hidden"}}
				pageSizeOptions={[10,20,25,50,75,100]}
				NoDataComponent={NoDataComponent}
				onFetchData={(state, instance) => {
					props.onFetchServiceRequests(instance, true);
					// if (props.page === 0) instance.state.page = 0;
				}}
				// getTdProps={(state, rowInfo, column) => {
				//   if (column && column.id !== "checkbox") {
				//     return {
				//       onClick: e => props.onUserRowClick(rowInfo)
				//     };
				//   } else {
				//     return { onClick: (e, h) => h() };
				//   }
				// }}
				NextComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Next
					</Button>
				)}
				PreviousComponent={(instance) => (
					<Button className="mt3" {...instance}>
						Previous
					</Button>
				)}
			/>
		</>
	);
}
